import React, { useState } from "react";
import { CustomInput } from "../main_comps/custom_input/CustomInput";
import CustomDatePicker from "../main_comps/custom_date_picker";
import {
  LineSymbol,
  RightArrow,
  Searchopt,
} from "../../../utility/constants/assetsManager";

const FilterComponent = ({ filters }) => {
  const [searching, setSearching] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [name, setName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    fontWeight: "400",
    fontSize: "14px",
    color: "#6C6B6B",
  };
  const containerStyle = {
    height: "28px",
    width: "250px",
    border: "none",
    outline: "none",
  };

  const CallingApi = (names) => {};
  return (
    <div style={styles.maindiv}>
      {filters.map((item, index) => (
        <div style={{ marginTop: "10px" }}>
          {item?.type === "searchAction" && (
            <div
              style={{
                borderRadius: "8px",
                height: "30px",
                border: "0.5px solid #696969",
                width:"270px"
              }}
            >
              <div style={styles.searchdiv1}>
                <div
                  style={{
                    height: "28px",
                    // width: "20px",
                    background: "rgba(0, 0, 0, 0.05)",
                    paddingTop: "2px",
                    paddingLeft: "4px",
                  }}
                >
                  <Searchopt style={styles.image1} />
                </div>

                <div style={{ border: "0" }}>
                  <CustomInput
                    placeholder="Search actions"
                    inputcomponentStyles={{
                      ...inputStyle,
                    }}
                    inputStyles={{
                      ...containerStyle,
                      background: "rgba(0, 0, 0, 0.05)",
                      boxShadow: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {item?.type === "dateRange" && (
            <>
              <div style={styles.date} className="nk-date-filter">
                <CustomDatePicker
                  containerStyle={{
                    height: "28px",
                    width: "116px",
                    background: "rgba(203, 202, 202, 0.1)",
                    opacity: "0.6",
                    border: "0.5px solid #696969",
                    borderRadius: "4px",
                  }}
                  inputStyles={{ height: "28px" }}
                  fieldHoverStyles={{ borderColor: "none", outline: "none" }}
                  placeholder=""
                  value={fromDate}
                  onChange={setFromDate}
                />

                <p style={styles.ptag}>to</p>

                <CustomDatePicker
                  containerStyle={{
                    height: "28px",
                    width: "116px",
                    background: "rgba(203, 202, 202, 0.1)",
                    opacity: "0.6",
                    border: "0.5px solid #696969",
                    borderRadius: "4px",
                  }}
                  inputStyles={{ height: "28px" }}
                  placeholder=""
                  fieldHoverStyles={{ borderColor: "none", outline: "none" }}
                  value={toDate}
                  onChange={setToDate}
                />
              </div>
              <div
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.05)",
                  width: "286px",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              ></div>
            </>
          )}

          {item?.type === "search" && (
            <>
              <div
                style={styles.customer}
                onClick={() => {
                  setSearching(!searching);
                  setCurrentId(index);
                }}
              >
                <LineSymbol style={styles.image2} />
                <p style={styles.ptag1}>{item?.name}</p>
                <p style={{ minWidth: "100px" }}>
                  {index === 2 && <>{name}</>}
                </p>

                <RightArrow style={styles.image2} />
              </div>
              {searching && currentId === index && (
                <>
                  <div style={styles.maindiv1}>
                    <div style={styles.searchdiv2}>
                      <div
                        style={{
                          height: "28px",
                          // width: "20px",
                          background: "rgba(0, 0, 0, 0.05)",
                          paddingTop: "2px",
                          paddingLeft: "4px",
                        }}
                      >
                        <Searchopt style={styles.image1} />
                      </div>

                      <div style={{ border: "0" }}>
                        <CustomInput
                          placeholder="Search"
                          inputcomponentStyles={{
                            ...inputStyle,
                          }}
                          inputStyles={{
                            ...containerStyle,
                            background: "rgba(0, 0, 0, 0.05)",
                            boxShadow: "none",
                          }}
                        />
                        {index === 2 && (
                          <>
                            <ul>
                              <li
                                onClick={() => {
                                  setName("Nikhil");
                                  setCurrentId(index);
                                  setSearching("");
                                  CallingApi("Nikhil");
                                }}
                              >
                                Nikhil
                              </li>
                              <li
                                onClick={() => {
                                  setName("surya");
                                  setCurrentId(index);
                                  setSearching("");
                                  CallingApi("surya");
                                }}
                              >
                                surya
                              </li>
                              <li
                                onClick={() => {
                                  setName("kartik");
                                  setCurrentId(index);
                                  setSearching("");
                                  CallingApi("kartik");
                                }}
                              >
                                kartik
                              </li>
                            </ul>
                          </>
                        )}
                      </div>
                    </div>
                    <div style={styles.line}></div>
                  </div>
                </>
              )}
            </>
          )}
          {item?.type === "input" && (
            <>
              <CustomInput placeholder="type Something" />
            </>
          )}
        </div>
      ))}
    </div>
  );
};

const styles = {
  // maindiv: {
  //   height: "212px",
  //   width: "316px",
  //   border: "1px solid black",
  //   background: "#FFFFFF",
  // },

  maindiv: {
    width: "306px",
    height: "272px",
    background: "#FFFFFF",
    borderRadius: "5px",

    position: "absolute",
    zIndex: "10",
    padding: "8px 12px 8px 12px",
    boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
  },
  ptag1: {
    color: "#1C1C1C",
    fontWeight: "400",
    fontSize: "14px",
    paddingLeft: "15px",
    minWidth: "140px",
  },

  filter: {
    height: "272px",
    width: "306px",
    zIndex: "10",
    position: "absolute",
    borderRadius: "8px",
    padding: "8px 12px 8px 8px",
    background: "#FFFFFF",
    border: "1px solid black",
  },
  line: {
    width: "286px",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    marginTop: "10px",
  },
  date: {
    height: "28px",
    width: "286px",
    borderRadius: "8px",
    display: "flex",
    marginBottom: "10px",
  },
  ptag: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px",
    margin: "0 12px 0 12px",
  },
  from: {
    height: "28px",
    width: "110px",
    background: "rgba(203, 202, 202, 0.1)",
    opacity: "0.6",
    border: "0.5px solid #696969",
    borderRadius: "4px",
    padding: "8px",
    //margin:"8px 10px 0 5px"
  },

  image2: {
    height: "16px",
    width: "16px",
  },
  searchdiv1: {
    display: "flex",
    height: "28px",
    width: "270px",

    //paddingLeft: "4px",

    borderRadius: "8px",
  },
  searchdiv2: {
    display: "flex",
    height: "28px",
    width: "270px",
    margin: "10px 0 0 10px",

    borderRadius: "8px",
  },
  image1: {
    height: "13px",
    width: "13px",
    marginTop: "2px",
  },
  customer: {
    display: "flex",
    marginTop: "15px",
    cursor: "pointer",
  },
  maindiv1: {
    height: "176px",
    width: "306px",
    borderRadius: "8px",
    right: "200px",
    background: "#FFFFFF",
    position: "absolute",

    left: "320px",
    padding: "8px 12px 8px 8px",
    boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
  },
};

export default FilterComponent;
